import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {PlatformLocation} from '@angular/common';

@Component({
  selector: 'component-questionnaire-head-photo',
  templateUrl: './component.questionnaire-head-photo.html',
  styleUrls: ['./component.questionnaire-head-photo.css']
})

export class ComponentQuestionnaireHeadPhoto implements OnInit, AfterViewInit {
  @Input() questionnaireLevel: number; //问卷等级
  @Input() questionnaireHeadPhotoUrlArray: any; //问卷头像url

  origin: string; //origin
  constructor(private platformLocation: PlatformLocation) {}

  ngOnInit() {
    this.origin = this.platformLocation['location']['origin'];
  }

  ngAfterViewInit(){

  }


}



// WEBPACK FOOTER //
// ./src/component/questionnire/child-photo-head/component.questionnaire-head-photo.ts